var map = {
	"./symbol_0.png": "0016",
	"./symbol_1.png": "ad22",
	"./symbol_10.png": "f20c",
	"./symbol_11.png": "dffd",
	"./symbol_12.png": "419d",
	"./symbol_2.png": "7c0c",
	"./symbol_3.png": "4191",
	"./symbol_4.png": "15b0",
	"./symbol_5.png": "2dd9",
	"./symbol_6.png": "c142",
	"./symbol_7.png": "2df0",
	"./symbol_8.png": "5ba7",
	"./symbol_9.png": "0bff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9bf";